import React, { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";
import backgroundBanner from "./backgroundbanner.jpg";
import backgroundBannerMobile from "./backgroundbannermobilonly.jpg";

const Invitatie = () => {
  const { t } = useTranslation();
  const [invitatie, setInvitatie] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const code = window.location.pathname.split("/").pop();

  useEffect(() => {
    const fetchInvitatie = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(
          `https://api.evenimente-ara.ro/api/invitatie/${code}`
        );
        if (!res.ok) {
          throw new Error(t("invitation_not_found"));
        }
        const data = await res.json();
        setInvitatie(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInvitatie();
  }, [code, t]);

  if (loading)
    return (
      <div className="bg-ara-gradient flex min-h-screen flex-col items-center justify-center gap-4 px-4">
        <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-[#0066A6]/25 border-t-[#0066A6]" />
        <p className="text-sm font-medium text-[#003B5C]">{t("loading_invitation")}</p>
      </div>
    );

  if (error)
    return (
      <div className="bg-ara-gradient flex min-h-screen items-center justify-center px-4">
        <div className="sp-card w-full max-w-md rounded-3xl border border-white/60 bg-white/90 p-8 text-center shadow-2xl shadow-red-500/10 backdrop-blur-sm">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-50">
            <svg className="h-8 w-8 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7.5v5M12 16.5h.01" strokeLinecap="round" />
            </svg>
          </div>
          <p className="text-base font-semibold text-[#003B5C]">{error}</p>
        </div>
      </div>
    );

  return (
    <div
      className="ara-hero"
      style={{
        ...styles.body,
        "--bg-desktop": `url(${backgroundBanner})`,
        "--bg-mobile": `url(${backgroundBannerMobile})`,
      }}
    >
      <div style={styles.card}>
        <h1 style={styles.title}>
          {t("invitation_for")} {invitatie.fullName}
        </h1>
        <p>
          <span style={styles.label}>{t("email")}:</span> {invitatie.email || "—"}
        </p>
        <p>
          <span style={styles.label}>{t("phone")}:</span> {invitatie.phone || "—"}
        </p>
        <p>
          <span style={styles.label}>{t("address")}:</span> {invitatie.address || "—"}
        </p>
        <p>
          <span style={styles.label}>{t("company")}:</span> {invitatie.company || "—"}
        </p>
        <div style={styles.qrContainer}>
          <QRCodeCanvas
  value={`${invitatie.col1}`}
  size={250} // mai mare pt claritate
  bgColor="#ffffff"
  fgColor="#000000"
  level="H"
  includeMargin={true}
  style={{
    padding: 20,
    background: "#ffffff",
    borderRadius: 12,
  }}
/>

        </div>
        <p>
          <span style={styles.label}>{t("location")}:</span> {t("location_value")}
        </p>
        <p>
          <span style={styles.label}>{t("date")}:</span> {t("date_value")}
        </p>
      </div>
    </div>
  );
};

const styles = {
  body: {
    margin: 0,
    minHeight: "100vh",
    backgroundSize: "cover",
    backgroundPosition: "center",
    fontFamily: "'Montserrat', sans-serif",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  card: {
    background: "rgba(0, 0, 0, 0.6)",
    borderRadius: 15,
    maxWidth: 600,
    width: "100%",
    padding: 30,
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)",
    textAlign: "center",
  },
  title: {
    marginBottom: 10,
    fontWeight: 700,
    fontSize: "2.5rem",
    letterSpacing: 1,
    color: "#fcfeff",
    textShadow: "1px 1px 5px #000",
  },
  label: {
    fontWeight: 700,
    color: "#AAD8FF",
  },
  footer: {
    marginTop: 30,
    fontSize: "0.9rem",
    color: "#ccc",
  },
  qrContainer: {
    marginTop: 25,
    marginBottom: 10,
    justifyContent: 'center',
    display:'flex'
  },
  loading: {
    color: "#fff",
    fontSize: "1.2rem",
    textAlign: "center",
    marginTop: "40vh",
  },
  error: {
    color: "#FF6B6B",
    fontSize: "1.2rem",
    textAlign: "center",
    marginTop: "40vh",
  },
};

export default Invitatie;
